import { handleize } from "@/helpers/userHelpers";
import { useRouter } from 'next/compat/router';
import React, { useEffect, useRef, useState } from 'react';
import Srcset from '@/components/common/Srcset';
import {
  Highlight,
  connectRange
} from "react-instantsearch-dom";
import { PLPFiltersTracking } from "@/components/common/Tracking";

const RangeInput = ({ currentRefinement, router, refine, pathnameRouter, defaultRefinement,setMinMaxApplied }) => (
  <form className="price_range_aria" id="myForm">
    <div className="input-group">
      <label className='xx-small'>Min</label>
      <input
      type="number"
      className="input-control small"
      min="0"
      autoComplete="min"
      aria-label="min-value"
      value={defaultRefinement.min || ''}
      onChange={event =>
          {
            setMinMaxApplied(currentRefinement)
            refine({
             ...currentRefinement,
            min: event.currentTarget.value,
          });
          sessionStorage.setItem(`${pathnameRouter}~minPrice`, event.currentTarget.value)
        } 
        }
      />
    </div>
    {/* {' - '} */}
    <div className="input-group">
      <label className='xx-small'>Max</label>
      <input
        type="number"
        value={`${defaultRefinement.max}` || ''}
        className="input-control small"
        autoComplete="max"
        aria-label="max-value"
        onChange={event =>{
          setMinMaxApplied(currentRefinement)
            refine({
              ...currentRefinement,
              max: event.currentTarget.value,
            })
            sessionStorage.setItem(`${pathnameRouter}~maxPrice`, event.currentTarget.value)
          }
        }
      />
    </div>
  </form>
);

const CustomRangeInput = connectRange(RangeInput);


const FilterWrapper = (props) => {
  const { styles,lableFilter, searchable, isColor, items, hexCode, 
    brand_name, isFromSearch, slideToggle, refine, colorCode, searchForItems } = props;
  const [appliedFilterCount, setAppliedFilterCount] = useState();
  const [minMaxApplied,setMinMaxApplied] = useState()
  
  const [disablePriceFilter, setDisablePriceFilter] = useState();

  const ulRef = useRef(null);
  const router = useRouter()
  const searchRef = useRef(null);
  useEffect(() => {
    setAppliedFilterCount(0);
    filterCountFun();
    setTimeout(() => {
      filterCountFun();
    }, 2000);
  });
  const resetSearch = () => {
    if (!searchRef || !searchRef.current) {
      return
    }
    searchRef.current.value  = '';
  }
  const filterCountFun = () => {
    if (!ulRef || !ulRef.current) {
      return
    }
    
    let count = ulRef.current.querySelectorAll("input:checked").length;
    let numberRange = ulRef.current.querySelectorAll("input[type=number]");
    let incrementCont = false;
    if(numberRange) {
      numberRange.forEach((item, index) => {
        if(item.value) {
          incrementCont = true;
        }
      });
    }
    if(incrementCont) {
      count+=1;
    }
    setAppliedFilterCount(count);
  }

  const handleBlurOut = (target, placeholderText) => {

    if(target) {
      target.placeholder = placeholderText
    }
  }

  let [minPrice, maxPrice] = [undefined, undefined]
  let defaultRefinement = {}
  let pathnameRouter = router.pathname
  if(pathnameRouter === "/[...pages]") {
    pathnameRouter = router.query.pages.join('/')
  }

  if(typeof window !== "undefined") {

    if(sessionStorage.getItem(`${pathnameRouter}~minPrice`)) {
      minPrice = +sessionStorage.getItem(`${pathnameRouter}~minPrice`)
      defaultRefinement['min'] = minPrice
    }
    
    if(sessionStorage.getItem(`${pathnameRouter}~maxPrice`)) {
      maxPrice = +sessionStorage.getItem(`${pathnameRouter}~maxPrice`)
      defaultRefinement['max'] = maxPrice
    }
  }
useEffect(()=>{
  if(Object.keys(defaultRefinement).length){
    setDisablePriceFilter(true) 
  }else{
    setDisablePriceFilter(false)
  }

})
 

  return (
    <div>
      <div className={`${styles.filter_item} filter_item filter_main_item`}>
        <div className={`${styles.filter_item_head}`} onClick={(e) => {
          e.currentTarget.parentElement.classList.toggle('active')
          let nextElementSibling = e.currentTarget.nextElementSibling
          if (nextElementSibling.classList.contains('search_hide')) {
            nextElementSibling = nextElementSibling.nextElementSibling
          }
          slideToggle(nextElementSibling)
        }}>
          <div className={`${styles.filter_item_title} normal-sm normal-md small-xs`}>{lableFilter === 'Brand' ? 'Designers' :lableFilter }</div>
          <div className={`${styles.filter_item_action}`}>
            {appliedFilterCount ? <span className={`${styles.filter_action_txt} x-small filter_count`}>{(appliedFilterCount > 1) ? `${appliedFilterCount} filters selected` : `${appliedFilterCount} filter selected`}</span> : null}

            <span className={`${styles.filter_action_plus}`}>
              <Srcset
                height="15"
                width="15"
                alt="Account"
                requirePath={true}
                svgFile={true}
                src={"images/Icons/Cross/Large.svg"}
              />
            </span>
          </div>
        </div>
        <div className={`${styles.filter_item_body} filter_body`} style={{ display: 'none' }}>


          {searchable && <div className='inner_searchbar'>
            <input
              type="search" ref={searchRef} className="input-control small" placeholder="Search designers"
              onFocus={e => e.currentTarget.placeholder = ''}
              onChange={event => searchForItems(event.currentTarget.value)}
              onBlur={e => handleBlurOut(e.currentTarget, 'Search designers')}
            />
          </div>}

          {searchable && !items.length && <div>No Results</div> }

          <ul className={`filter_item_list${isColor ? " color-ul" : ""}`} ref={ulRef}>

            {items.map((item, i) => {

              if (item.label == "price-range-input") {
                return <li><CustomRangeInput attribute="price" min={0} router={router} defaultRefinement={defaultRefinement}  pathnameRouter={pathnameRouter} setMinMaxApplied={setMinMaxApplied}/></li>
              }
              if (item.label != "All") {
                return (
                
                  <li key={item.label} className={`${hexCode ? `${styles.is_color}` : null}`}>
                    <div className="custom-checkbox">
                      <input type='checkbox' disabled={(lableFilter == "Price" && disablePriceFilter) || item.label === brand_name  } id={`${handleize(item.label)}_${i}`} checked={item.isRefined ? 'checked' : ''} onChange={e => {
                        if(lableFilter == "Price"){
                          //if price filter is getting selected for the first time to avoid duplicate tracking
                          !item.isRefined && PLPFiltersTracking(((lableFilter==="Category"&&"Cat")||(lableFilter==="Subcategory"&&"Subcat")||(lableFilter!=("Category"||"Subcategory")&&lableFilter)), item.label, false);
                        }
                        else {
                          //If computed event label contains Category, subcategory replace string with Cat,Subcat
                          PLPFiltersTracking(((lableFilter==="Category"&&"Cat")||(lableFilter==="Subcategory"&&"Subcat")||(lableFilter!=("Category"||"Subcategory")&&lableFilter)), item.label, item.isRefined);
                        }
                        refine(item.value);
                        filterCountFun();
                        resetSearch();
                        sessionStorage.setItem(`${pathnameRouter}~${lableFilter}`, item.value.toString())
                      }}
                      ></input>
                      <label htmlFor={`${handleize(item.label)}_${i}`} className='small'>
                        {hexCode ? (
                          <div className='color-label-outter' >
                            <div className={`${styles.color_label_inner}`} style={{ backgroundColor: colorCode.data[item.label] }}></div>
                          </div>
                        ) : (
                          ''
                        )}
                        <span>
                          {isFromSearch ? (
                            <Highlight attribute="label" hit={item} />
                          ) : (
                            item.label
                          )}
                        </span>
                      </label>
                    </div>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default FilterWrapper;